export default __webpack_public_path__ + "57265097b0ac5bed50a049f1c127bce5.png";